import React, { ReactNode } from 'react'
import { UserProvider } from 'context/user'

import Routing from 'components/Routing'
import { useAuth0 } from '@auth0/auth0-react'
import { LoadingPage } from './Loading'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

export default function App (): ReactNode {
  const { isLoading } = useAuth0()
  if (isLoading) return <LoadingPage />

  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <Routing />
      </UserProvider>
    </QueryClientProvider>
  )
}
